import { Stack, Typography } from "@mui/material";
import type { ISmartrrOrderFromDb } from "@smartrr/shared/entities/Order";
import { CardLogo, ValidCards } from "@smartrr/shared/icons/Aquarius/cardLogos";
import capitalize from 'lodash/capitalize';
import React from "react";

export const OrderHistoryPaymentInfo = ({ order }: { order: ISmartrrOrderFromDb }) => {
  const {
    maskedNumber,
    cardBrand = "",
    cardExpirationMonth = 0,
    cardExpirationYear = 0,
    lastDigits = "",
  } = order.sts.length ? order.sts[0].pmtMth : (order.pmtMthJson! ?? {});
  const maskedNumDisplay = maskedNumber ? maskedNumber : lastDigits ? `•••• ${lastDigits}` : "";
  return (
    <Stack>
      <Stack spacing={3} direction="row" alignItems="center">
        <Typography variant="body1">{capitalize(cardBrand ?? "Unknown Card")}</Typography>
        {!!cardBrand && <CardLogo cardName={cardBrand as ValidCards} />}
      </Stack>
      {maskedNumDisplay ? <Typography variant="body1">{maskedNumDisplay}</Typography> : null}
      {cardExpirationMonth && cardExpirationYear ? (
        <Typography variant="body1">
          Ex. {cardExpirationMonth}/{cardExpirationYear}
        </Typography>
      ) : null}
    </Stack>
  );
};
